import React from 'react'
import classnames from 'classnames'

import * as S from './styles'

export default function AlertPopover(props) {
  let position = ''
  props.position === 'bottom' ? position = 'arrowBoxBottom' : position = 'arrowBoxTop'

  let type = 'warning'
  if (props.type === 'danger') {
    type = 'danger'
  }

  return (
    <S.PopoverContainer data-cy={props.dataCy} className={props.active ? 'active' : ''} type={type}>
      <div className={classnames(position, 'arrowBox')}>
        <strong>{props.title}</strong>
        {props.content}
      </div>
    </S.PopoverContainer>
  )
}
